import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SecurityCoverUI from '../../../components/superUser/loan/assessment/SecurityCoverUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const SecurityCoverPageUI = ({ context, errorList, loan, loanInterestRate, onRefreshClick, toggleEditable, editable
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_intr' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !loanInterestRate} loan={loan} page='securityCover'
    dimension='w768'
  >
    {
      (!loan || !errorList || !loanInterestRate) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && loanInterestRate &&
      <SecurityCoverUI
        context={context}
        loan={loan}
        loanInterestRate={loanInterestRate}
        onRefreshClick={onRefreshClick}
        toggleEditable={toggleEditable}
        editable={editable}
      />
    }
  </SuperUserLoanPageUI>

export default SecurityCoverPageUI
